var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _circle3, _circle4, _circle5, _circle6, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _circle7, _circle8, _path13, _path14, _path15, _rect, _circle9, _path16, _rect2, _rect3, _rect4, _circle0, _circle1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 87,
    viewBox: "0 0 280 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.906 44.1576C103.906 35.3211 111.069 28.1576 119.906 28.1576H154.532C163.369 28.1576 170.532 35.3211 170.532 44.1576V70.8525C170.532 79.689 163.369 86.8525 154.532 86.8525H119.906C111.069 86.8525 103.906 79.689 103.906 70.8525V44.1576ZM141.185 58.9332C144.01 57.4891 145.944 54.5502 145.944 51.1597C145.944 46.341 142.038 42.4348 137.219 42.4348C132.4 42.4348 128.494 46.341 128.494 51.1597C128.494 54.5502 130.428 57.4891 133.253 58.9332V69.1142C133.253 71.3045 135.029 73.0801 137.219 73.0801C139.409 73.0801 141.185 71.3045 141.185 69.1142V58.9332Z",
    fill: "#0e0333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.769 31.3303V18.7249C119.769 13.2021 124.246 8.7249 129.769 8.7249H144.669C150.192 8.7249 154.669 13.2021 154.669 18.7249V31.3303",
    stroke: "#0e0333",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3571 27.3768L25.6819 70.9437C24.4289 74.2175 26.8461 77.731 30.3516 77.731H36.4646C38.65 77.731 40.5821 76.3117 41.2357 74.2264L46.7954 56.4885C47.1291 55.4238 48.6918 55.6226 48.7483 56.737L49.5719 72.9841C49.7067 75.6437 51.9024 77.731 54.5655 77.731H62.1067C65.291 77.731 67.664 74.794 66.9952 71.6808L57.7324 28.5626C56.9361 24.8561 53.6598 22.2088 49.8687 22.2088C46.5359 22.2088 43.5484 24.2643 42.3571 27.3768Z",
    fill: "#1ABC9C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50.052,
    cy: 15.8635,
    r: 6.34539,
    fill: "#EEBE5C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.7903,
    cy: 52.6927,
    r: 6.34539,
    fill: "#EEBE5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3632 81.6968C60.3632 83.8871 58.5876 85.6627 56.3974 85.6627C54.2071 85.6627 52.4315 83.8871 52.4315 81.6968C52.4315 79.5066 54.2071 77.731 56.3974 77.731C58.5876 77.731 60.3632 79.5066 60.3632 81.6968Z",
    fill: "#E74C3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4315 81.6968H52.8281L62.5124 81.8241C65.1587 81.7534 67.3759 83.8116 67.5018 86.4559H51.6383L52.4315 81.6968Z",
    fill: "#E74C3C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6363 81.6968C28.6363 83.8871 30.4119 85.6627 32.6022 85.6627C34.7925 85.6627 36.568 83.8871 36.568 81.6968C36.568 79.5066 34.7925 77.731 32.6022 77.731C30.4119 77.731 28.6363 79.5066 28.6363 81.6968Z",
    fill: "#E74C3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.568 81.6968H36.1714L26.4871 81.8241C23.8408 81.7534 21.6237 83.8116 21.4977 86.4559H37.3612L36.568 81.6968Z",
    fill: "#E74C3C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.0861,
    cy: 8.72491,
    r: 2.37952,
    fill: "#E74C3C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.1202,
    cy: 3.96587,
    r: 3.96587,
    fill: "#E74C3C"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5851,
    cy: 7.53515,
    r: 5.15563,
    fill: "#E74C3C"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.4651,
    cy: 13.0967,
    r: 5.9488,
    fill: "#E74C3C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6283 17.2866C54.5847 17.5856 52.4384 17.5097 51.412 16.5336",
    stroke: "#0e0333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.9507C0 25.2272 3.01848 22.2087 6.74196 22.2087H50.4293V22.2087C53.9256 22.2087 56.9447 24.656 57.6683 28.0766L59.2793 35.6927H6.74196C3.01848 35.6927 0 32.6742 0 28.9507V28.9507Z",
    fill: "#383E63"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7171 24.35L23.8811 39.6352C25.6006 41.7959 25.243 44.9414 23.0822 46.661L20.3562 48.8304C18.1954 50.5499 15.0499 50.1922 13.3304 48.0315L1.78908 33.5288C1.44518 33.0967 1.51671 32.4676 1.94885 32.1237L11.7171 24.35Z",
    fill: "#383E63"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M270.07 78.7032C271.196 80.5816 273.632 81.1912 275.511 80.0648C277.389 78.9383 277.999 76.5024 276.872 74.624C275.746 72.7456 273.31 72.1359 271.431 73.2624C269.553 74.3888 268.943 76.8247 270.07 78.7032Z",
    fill: "#EEBE5C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M276.872 74.624L276.532 74.828L268.292 79.9176C265.986 81.2179 265.143 84.1233 266.395 86.4559L280 78.2975L276.872 74.624Z",
    fill: "#EEBE5C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M230.609 81.7185C230.609 83.9088 232.385 85.6844 234.575 85.6844C236.765 85.6844 238.541 83.9088 238.541 81.7185C238.541 79.5282 236.765 77.7527 234.575 77.7527C232.385 77.7527 230.609 79.5282 230.609 81.7185Z",
    fill: "#EEBE5C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M238.541 81.7185H238.144L228.46 81.8458C225.814 81.7751 223.596 83.8333 223.471 86.4776H239.334L238.541 81.7185Z",
    fill: "#EEBE5C"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 6.34539,
    transform: "matrix(-1 0 0 1 248.371 21.4374)",
    fill: "#DFC389"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 6.34539,
    transform: "matrix(-1 0 0 1 240.556 38.2022)",
    fill: "#DFC389"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M242.965 23.3479C244.009 23.6469 245.759 23.8186 246.785 22.8425",
    stroke: "#0e0333",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M253.372 31.8243L238.004 37.6488L260.618 73.9717C262.071 76.3062 265.137 77.0288 267.48 75.589L272.501 72.5039C274.854 71.0582 275.589 67.9789 274.143 65.6262L253.372 31.8243Z",
    fill: "#0038FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M254.274 40.7149L238.865 33.8931L228.957 70.869C228.243 73.5363 229.826 76.278 232.493 76.9927L238.249 78.535C240.88 79.24 243.591 77.7094 244.347 75.0925L254.274 40.7149Z",
    fill: "#0038FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20.3974,
    height: 7.13856,
    rx: 3.56928,
    transform: "matrix(-0.962802 -0.270208 -0.270208 0.962802 261.427 11.0638)",
    fill: "#0038FF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 7.93173,
    transform: "matrix(-1 0 0 1 246.472 35.7145)",
    fill: "#E74C3C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M258.947 40.8926L253.255 31.6266L244.037 28.1629L221.442 34.2171C218.775 34.9318 217.192 37.6735 217.907 40.3409L219.247 45.3422C219.947 47.9564 222.601 49.5387 225.233 48.9124L258.947 40.8926Z",
    fill: "#E74C3C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 203.699,
    y: 24.2782,
    width: 3.17269,
    height: 29.7593,
    rx: 1,
    transform: "rotate(-17.8968 203.699 24.2782)",
    fill: "#0e0333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 211.798,
    y: 25.4158,
    width: 3.17269,
    height: 7.36895,
    rx: 1,
    transform: "rotate(71.7233 211.798 25.4158)",
    fill: "#0e0333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 212.143,
    y: 30.9583,
    width: 3.17269,
    height: 5.5282,
    rx: 1,
    transform: "rotate(71.7233 212.143 30.9583)",
    fill: "#0e0333"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.548,
    cy: 56.0226,
    r: 3.98181,
    transform: "rotate(-63.1123 215.548 56.0226)",
    stroke: "#0e0333",
    strokeWidth: 3
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    r: 6.34539,
    transform: "matrix(-1 0 0 1 212.023 44.0805)",
    fill: "#DFC389"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockPeople);
export default __webpack_public_path__ + "static/media/lock-people.d7ed1c60c013f27d3b7a84db6431a922.svg";
export { ForwardRef as ReactComponent };